/* Component Dependencies */
var stickySummaryTemplate = require('templates/searchSummary-sticky.hbs');
var stickySummaryHWSTemplate = require('templates/searchSummary-sticky-hws.hbs');
var stickySummaryCartStickyTemplate = require('templates/searchSummary-cartSticky.hbs');
var stickySummaryModifyStickyTemplate = require('templates/searchSummary-modifySticky.hbs');
var stickySummaryV2Template = require('templates/searchSummary-v2.hbs');
//var offerNextGenSearchSummaryTemplate = require('templates/offerNextGenSearchSummary.hbs');

var AriesComponent = require('libs/aries-component');
var ResponsiveUtils = require('utils/responsiveUtils');
var $ = require('jquery');
require('libs/jquery.dotdotdot');

AriesComponent.create({
  type: 'searchSummary',
  template: {
    'searchSummary-sticky': stickySummaryTemplate,
    'searchSummary-sticky-hws': stickySummaryHWSTemplate,
    'searchSummary-cartSticky': stickySummaryCartStickyTemplate,
    'searchSummary-modifySticky': stickySummaryModifyStickyTemplate,
    'searchSummary-v2': stickySummaryV2Template,
 //   'offerNextGenSearchSummary': offerNextGenSearchSummaryTemplate
  },
  subscribe: {
    'TOGGLE_STICKY_FORM_EDIT_BUTTON': 'toggleEditArrow',
    'TOGGLE_STICKY_PANEL': 'toggleSearchSticky',
    'HIDE_STICKY_SEARCH_FORM': 'hideStickySearchForm',
    'STICKY_SCROLL_TOP': 'scrollPageTop',
    'STICKY_PANEL_RESIZE':'stickyPanelResize',
    'TOGGLE_BORDER':'toggleBorderFunc',
    'OPEN_SEARCH_SUMMARY_FORM': 'openSearchSummaryForm'
  },
  events: {
    'click #destination,#staydates,#guestsrooms,a#editSearch,#sellOptions,.js-edit-search,#multiRateSearch': 'stickySearchTrigger',
    'click .js-edit-panel-search': 'toggleEditPanel'
  },
  bindEvents: function() {
    var _self = this;
    this.responsiveUtils = this.$el.hasClass('tile-search-summary-modify-sticky') ? ResponsiveUtils.create({
      resizeEventHandler: _.bind(this.handleStickyBehaviour, this)
    }) : ResponsiveUtils.create();
    this.responsiveUtils.init();
    this.$el.find('#destination .info-link').dotdotdot();
    this.cache = {};
    this.cache.defaultEditSearchObj = this.$el.find('#search-summarized #editSearch');
    this.cache.editSearchObj = (this.cache.defaultEditSearchObj.length) ? (this.cache.defaultEditSearchObj) : (this.$el.find('#cartSearchSummarized #editSearch'));

    if(this.$el.hasClass('tile-search-summary-modify-sticky')){
      if(this.responsiveUtils.isMobileOrTablet())
        setTimeout(function(){
          window.MI_PubSub.publish('searchSummary/removeSticky');
        })
    }

    if ($('.tile-search-filter').hasClass('filters-v2') && 
							!$('.tile-search-filter').hasClass('type-E')) {
      _self.isPropertyRecordsDisabled = true;
    } else {
      _self.isPropertyRecordsDisabled = false;
    }
  },
  unBindEvents: function($) {
    $('*[data-component-id="' + this.$el.data('component-id') + '"]').off();
    $('*[data-component-id="' + this.$el.data('component-id') + '"] *').off();
  },
  handleStickyBehaviour: function(){
    if(this.responsiveUtils.isMobileOrTablet()){
      window.MI_PubSub.publish('searchSummary/removeSticky');
    } else {
      window.MI_PubSub.publish('searchSummary/addSticky');
    }
  },
  hideStickySearchForm: function(toggleFlag,resizeMapView,suppressHideSearchEvent) {
    var _self = this;

    if (_self.cache.editSearchObj.hasClass('open') && this.responsiveUtils.isMobileOrTablet()) {
      return;
    }
    if (!suppressHideSearchEvent) {
      var stickysearchForm = this.$el.closest('[class*="sub-section"]').next().find('.m-homepage-hsearch');
      var associateStickySearchForm = this.$el.closest('[class*="sub-section"]').next().find('.tile-adv-search-associate-form');
      var initScrollSellStrategy={
        'scroll':true
      };
      if(_self.cache.editSearchObj.hasClass('open')) {
        if(associateStickySearchForm.length){
          associateStickySearchForm.removeClass('is-toggled');
          _self.pubsub.publish('TOGGLE_STICKY_SEARCH_FORM', [undefined, associateStickySearchForm, _.bind(_self.toggleEditArrow, _self)]);
          _self.pubsub.publish('SELL_STRATEGY_SCROLL',[initScrollSellStrategy]);
        }
        else{
          stickysearchForm.removeClass('is-toggled');
          _self.pubsub.publish('TOGGLE_STICKY_SEARCH_FORM', [undefined, stickysearchForm, _.bind(_self.toggleEditArrow, _self),resizeMapView]);  
        }
        
      }
    }
  },

  stickySearchTrigger: function(e) {
    e.preventDefault();
    e.stopPropagation();
    var _self = this,
        $obj = $(e.currentTarget).attr('data-focus'),
        associateStickySearchForm = this.$el.closest('[class*="sub-section"]').next().find('.tile-adv-search-associate-form'),
        stickysearchForm = this.$el.closest('[class*="sub-section"]').next().find('.m-homepage-hsearch');
    var initScrollSellStrategy={
        'scroll':true
    };
    if(associateStickySearchForm.length){
        associateStickySearchForm.removeClass('is-toggled');
        _self.pubsub.publish('TOGGLE_STICKY_SEARCH_FORM', [$obj, associateStickySearchForm, _.bind(_self.toggleEditArrow, _self)]);
        _self.pubsub.publish('HIDE_FILTERS_PANEL');
        _self.pubsub.publish('SELL_STRATEGY_SCROLL',[initScrollSellStrategy]);
    }
    else{
        stickysearchForm.removeClass('is-toggled');
        _self.pubsub.publish('TOGGLE_STICKY_SEARCH_FORM', [$obj, stickysearchForm, _.bind(_self.toggleEditArrow, _self)]);
        _self.pubsub.publish('HIDE_FILTERS_PANEL'); 
    }
    this.$el.toggleClass('t-border-bottom t-border-color-standard-110');
    this.$el.find('.tile-search-summary').toggleClass('t-border-bottom t-border-color-standard-110');
  },

  toggleEditArrow: function(toggleFlag){
    var _self = this;

    _self.$el.toggleClass('remove-border');
    if(toggleFlag){
      _self.cache.editSearchObj.toggleClass('open');
    }else{
      _self.cache.editSearchObj.addClass('open');
    }
  },

  toggleSearchSticky: function(toggleFlag) {
    var _self = this;
    if(toggleFlag){
      window.MI_PubSub.publish('searchSummary/removeSticky');
    } else {
      window.MI_PubSub.publish('searchSummary/addSticky');
    }
    _self.enableNewSearchToolbar(toggleFlag);
  },

  scrollPageTop: function() {
    $(window).scrollTop(this.$el.offset().top);
    this.pubsub.publish('STICKY_SCROLL_TO_TOP');
  },

  stickyPanelResize: function(toggleFlag) {
    if (toggleFlag == 'hide') {
      this.$el.hide();
    } else {
      this.$el.show();  
    }
  },

  toggleBorderFunc: function(data) {
     if(data == true){
           $(".tile-search-summary-sticky").removeClass("t-border-bottom t-border-color-standard-110");
     } else {
	   $(".tile-search-summary-sticky").addClass("t-border-bottom t-border-color-standard-110");
     }
  },
  openSearchSummaryForm: function(){
    this.$el.find('#multiRateSearch').trigger('click');
  },
  toggleEditPanel: function(event) {
    event.preventDefault();
    var $body = $('body');
    $(".tile-search-summary-sticky").hide();
    $(".m-homepage-hsearch").removeClass("is-hidden").addClass("is-opened").removeAttr("style");
		if (this.responsiveUtils.isMobile() || this.responsiveUtils.isTablet()) {
			$body.addClass('is-form-takeover');
		} else {
			$body.removeClass('is-form-takeover');
		}
		this.dateHandler.pickaDatePlugin.handleFormat();
  },
  enableNewSearchToolbar(toggleFlag){
    if(toggleFlag && this.isPropertyRecordsDisabled && this.responsiveUtils.isMobile()){
      if(!$('.tile-search-summary-scroll').hasClass('tile-search-summary-v2')){
        $('.js-edit-search').addClass('hide-edit-button');
        $('.all-filter-btn').addClass('fixed-filter-position');
        $('.l-dates-scroll').attr("id","l-dates-v2");
        $('.tile-search-summary-scroll').addClass('tile-search-summary-v2');
        $('.l-label-scroll').addClass('hide-edit-button');
      }
      $('.id-content-wrapper').addClass("id-content-wrapper-v2");
      $('.filters-v2').addClass('hide-suggested-filters');
      $('.all-filter-btn').addClass('all-filter-visibility');
      $('#map').addClass('map-position');
    }
    if(toggleFlag === false && this.isPropertyRecordsDisabled && this.responsiveUtils.isMobile()) {
      $('.js-edit-search').removeClass('hide-edit-button');
      $('.all-filter-btn').removeClass('fixed-filter-position');
      $('.l-dates-scroll').attr("id","");
      $('.tile-search-summary-scroll').removeClass('tile-search-summary-v2');
      $('.l-label-scroll').removeClass('hide-edit-button');
      $('.id-content-wrapper').removeClass("id-content-wrapper-v2");
      $('.filters-v2').removeClass('hide-suggested-filters');
      $('.all-filter-btn').removeClass('all-filter-visibility');
      $('.filters-v2').css('visibility','visible');
      $('#map').removeClass('map-position');
    }
  }
});
